import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllFarms = async (filters, page, size) => {
  try {
    const response = await api.get(`/farm`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createFarm = async (farmData) => {
  try {
    const response = await api.post('/farm', farmData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error creating fazenda');
  }
};

export const getFarmData = async (farmId) => {
  try {
    const response = await api.get(`/farm/${farmId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados da fazenda.');
  }
};

export const updateFarm = async (farmId, data) => {
  try {
    const response = await api.put(`/farm/${farmId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar a fazenda.');
  }
};